export default __webpack_public_path__ + "static/media/Octocat.363cb5ed.png";